import jwtDecode from "jwt-decode";
import isAccessTokenExpired from "./isTokenExpired";

const getAccessTokenExpirationFromNow = (accessToken: string) => {
  if (!accessToken) {
    console.warn('A valid token must be provided!');
    return;
  }

  if(isAccessTokenExpired(accessToken)) {
    return 0;
  }

  const decodedToken: any = jwtDecode(accessToken);
  if(!decodedToken) {
    console.error('Unable to decode token!');
    return -1;
  }

  return (decodedToken.exp * 1000) - Date.now();
}

export default getAccessTokenExpirationFromNow;